import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import loading from "./components/Loading.vue"; //import loading component
import Loading1 from "./components/Loading1.vue"; //import loading component
import guide from "./components/Guide.vue"; //import guide component
import "./plugins/vuetify-money.js";
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
});
import Notifications from "vue-notification";
Vue.use(Notifications);

// Vue.use('vue-shortkey', { prevent: ['input', 'textarea', 'v-text-field', 'v-textarea'] })
Vue.use(require("vue-shortkey"), {
  prevent: ["input", "textarea", "v-text-field", "v-textarea"],
});
import velocity from "velocity-animate";
Vue.use(Notifications, { velocity });

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import store from "./store";

// cssVars()

Vue.use(BootstrapVue);

import vuetify from "@/plugins/vuetify"; // path to vuetify export

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
    "https://stackpath.bootstrapcdn.com/bootstrap/5.0.0-alpha2/css/bootstrap.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue-icons.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    // '/print.css' //css stylings should be add to this file in public folder
  ],
};
Vue.use(VueHtmlToPaper, options);

//repeated data and methods imported here
Vue.mixin({
  components: { loading, guide, Loading1 },
  data() {
    return {
      baseUrl: "https://baas.ketabbaaz.com",
      // baseUrl: "http://localhost:3002",
      vLoading: false,
      vGuide: false,
      whenIsEmpty: "",
      vMoneyOptions: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
    };
  },
  methods: {
    validateEmail(email) {
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    toast(message, type) {
      this.$toast[type](message, {
        position: "top-center",
        icon: false,
        closeButton: false,
        timeout: 3000,
        draggablePercent: 0.2,
        hideProgressBar: true,
      });
    },
    checkCodeMeli(code) {
      if (code) {
        var L = code.length;

        if (L < 8 || parseInt(code, 10) == 0) return false;
        code = ("0000" + code).substr(L + 4 - 10);
        if (parseInt(code.substr(3, 6), 10) == 0) return false;
        var c = parseInt(code.substr(9, 1), 10);
        var s = 0;
        for (var i = 0; i < 9; i++)
          s += parseInt(code.substr(i, 1), 10) * (10 - i);
        s = s % 11;
        return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
        return true;
      } else return true;
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    // url: 'http://pm.sarmadbs.com/',
    // token: '6aad0847cc2ce0f4c4cb512c98be2a0a12c307ce'
  },
  router,
  // render: (h) => h(App),
  store,
  template: "<App/>",
  components: {
    App,
  },
  vuetify,
  mounted() {
    // document.dispatchEvent(new Event("render-event"));
    // if (window.localStorage.api_key === undefined) {
    // window.location = '/#/pages/login'
    // this.router.go('/pages/login')
    // router.push({ name: 'Login' })
    //return
    // }
  },
}).$mount("#app");
